import React from 'react';

/**
 * Shown after a sign-out in the Forms widget. The frame may not reach a SkySlope login made outside
 * it (its cookies can be blocked), so tell the user where else to sign out.
 */
export function WidgetSignedOut() {
  return (
    <div>
      <p>Signed out of this window</p>
      <p>If you&apos;re signed in to SkySlope in another tab, sign out there too.</p>
    </div>
  );
}
